// src/index.ts
import { extendBaseTheme } from "@stepstone-genesis/dresscode-base";
import { justengineers as baseJustengineersTheme } from "@stepstone-genesis/design-tokens";
var justengineers = extendBaseTheme("justengineers", baseJustengineersTheme);
export {
  justengineers
};
